import ReactGA4 from 'react-ga4';
import { call, put } from 'redux-saga/effects';

import {
  resetComponent,
  setCheckEmailExistsMessage,
  setCheckEmailExistsSuccess,
  setCheckEmailExistsWaiting,
  setContentByWarfareQualsSignup,
  setCounters,
  setCoupon,
  setCycle,
  setLoadingReferences,
  setPlans,
  setRates,
  setRatingExamQuestions,
  setReferences,
  setReferencesPmk,
  setSubscriptionMessage,
  setSubscriptionSuccess,
  setSubscriptionWaiting,
} from '../actions/signUpActions';
import { setUser } from '../actions/userActions';
import Services from '../services/index';
import history from '../utils/history';

export function* getAllPublicRatesSagas(action) {
  try {
    const response = yield call(
      Services.AccountSettingsService.getAllPublicRates,
    );
    yield put(setRates(response));
  } catch (err) {
    yield put(setRates([]));
  }
}

export function* loadPlansSagas(action) {
  try {
    const response = yield call(Services.SignUpService.getPlans);
    if (response !== undefined && response.length > 1)
      response.sort((a, b) => a.amount - b.amount);
    yield put(setPlans(response));
  } catch (err) {
    yield put(setPlans([]));
  }
}

export function* getReferencesDataSagas(action) {
  try {
    yield put(setLoadingReferences(true));
    const response = yield call(
      Services.SignUpService.getReferencesData,
      action.rateId,
      action.rank,
      action.dutyState,
    );

    const ratingExamQuestionsResponse = yield call(
      Services.SignUpService.loadRatingExamQuestions,
      action.rateId,
    );

    const questions = ratingExamQuestionsResponse.filter(
      (exq) =>
        String(exq.rank) === String(action.rank) &&
        String(exq.dutyState) === String(action.dutyState),
    );

    if (response.exam) {
      yield put(setCycle(response.exam.cycle));
    }

    yield put(
      setCounters(
        response.chaptersWithoutQuestions,
        response.chaptersCount,
        response.questionOccupationalCount,
        response.questionPmkCount,
        response.chaptersPmkCount,
        response.chaptersPmkWithoutQuestions,
      ),
    );

    yield put(setRatingExamQuestions(questions[0]));

    yield put(setReferences(response.references));
    yield put(setReferencesPmk(response.referencesPmk));
    yield put(setLoadingReferences(false));
  } catch (err) {
    yield put(setLoadingReferences(false));
    yield put(setReferences([]));
    yield put(setReferencesPmk([]));
    yield put(setCycle({}));
    yield put(setRatingExamQuestions(null));
    yield put(setCounters(0, 0, 0, 0, 0, 0));
  }
}

export function* getQualsDataSaga(action) {
  try {
    const response = yield call(Services.SignUpService.getQualsDataService);

    yield put(setContentByWarfareQualsSignup(response));
  } catch (err) {}
}

export function* checkEmailExistsSagas(action) {
  try {
    yield put(setCheckEmailExistsMessage({ exists: false, requested: false }));
    yield put(setCheckEmailExistsWaiting(true));
    const response = yield call(
      Services.SignUpService.checkEmailExists,
      action.email,
    );

    yield put(
      setCheckEmailExistsMessage({
        exists: response.emailExists,
        requested: true,
      }),
    );
    yield put(setCheckEmailExistsSuccess(true));
    yield put(setCheckEmailExistsWaiting(false));
  } catch (err) {
    yield put(setCheckEmailExistsWaiting(false));
    yield put(setCheckEmailExistsSuccess(false));
    yield put(setCheckEmailExistsMessage({ exists: false, requested: false }));
  }
}

export function* makeSubscriptionSagas(action) {
  try {
    const response = yield call(
      Services.SignUpService.subscribeUser,
      action.data,
    );
    yield put(setUser(response.user));

    yield put(setSubscriptionWaiting(false));
    yield put(setSubscriptionMessage(''));
    yield put(setSubscriptionSuccess(true));
    yield put(resetComponent());

    if (response.trackingPurchase) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'purchase',
        transactionId: response.trackingPurchase.transactionId,
        purchaseValue: response.trackingPurchase.purchaseValue,
        currency: response.trackingPurchase.currency,
        subscriptionType: response.trackingPurchase.subscriptionType,
      });
    }

    // Google Analytics 4
    ReactGA4.event({
      category: 'Subscribe',
      action: 'Successfully subscription',
      label: 'Sign Up Now',
    });

    history.push('/app/study');
  } catch (err) {
    yield put(setSubscriptionWaiting(false));
    yield put(setSubscriptionSuccess(false));
    yield put(setSubscriptionMessage(err.response.data));
  }
}

export function* checkCouponSagas(action) {
  try {
    const response = yield call(
      Services.SignUpService.checkCoupon,
      action.coupon,
      action.planId,
      action.isTrialUser,
      action.userId,
    );

    yield put(setCoupon(response));
  } catch {
    yield put(setCoupon('Not Valid'));
  }
}
